import React from "react";
import MessageField from "./MessageField";
import UserBalance from "./UserBalance";
import useApp from "../../../store/contexts/AppContext";
import { CHAT_ROOMS } from "../../../config/index";
import { makeStyles } from "@mui/styles"
import { ActiveChatInRoomStyle } from "./ActiveChatInRoomStyle";

const useStyles = makeStyles((theme) => ActiveChatInRoomStyle(theme));

export default function ActiveChatInRoom({ roomModerators }) {
  const classes = useStyles();
  const innerRoom = true;

  const {
    appState: { activeChat, userData },
  } = useApp();

  const otherUserForDirectChat =
    activeChat?.type === CHAT_ROOMS.TYPES.SINGLE
      ? activeChat?.room_participants.find(
          (participant) =>
            participant.id?.toString() !== userData.id?.toString()
        )
      : { username: activeChat.name };

  if (Object.keys(activeChat).length > 0) {
    return (
      <div className={classes.container}>
        {/* <UserBalance /> */}
        <MessageField
          otherUser={otherUserForDirectChat}
          innerRoom={innerRoom}
          roomModerators={roomModerators}
        />
      </div>
    );
  }
  return null;
}
